import { Link } from 'react-router-dom'
import { Logo } from '@/components/logo'
import { useCategories } from '@/features/categories/api'

export function SiteFooter() {
  const { data: categories } = useCategories()

  return (
    <footer className="bg-ink text-paper">
      <div className="mx-auto flex w-full max-w-[1320px] flex-col gap-8 px-4 py-12 sm:px-6 lg:flex-row lg:items-start lg:justify-between lg:px-10">
        <div className="max-w-xs">
          <Logo />
          <p className="mt-3 text-sm text-paper/65">
            Practical skills courses built around real briefs, execution, and
            proof of work.
          </p>
          <p className="mt-4 text-sm text-paper/65">
            2nd Floor, Global IME Bank Building
            <br />
            Bhaisepati Chowk, Lalitpur
            <br />
            +977 9700050034
          </p>
        </div>
        <div className="grid grid-cols-2 gap-8 text-sm sm:grid-cols-3">
          <div>
            <p className="font-medium text-paper">Learn</p>
            <ul className="mt-3 space-y-2 text-paper/65">
              <li>
                <Link to="/courses" className="hover:text-accent">
                  Browse courses
                </Link>
              </li>
              <li>
                <Link to="/verify" className="hover:text-accent">
                  Verify a certificate
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-medium text-paper">Teach</p>
            <ul className="mt-3 space-y-2 text-paper/65">
              <li>
                <Link to="/contact" className="hover:text-accent">
                  Become an instructor
                </Link>
              </li>
            </ul>
          </div>
          {categories && categories.length > 0 && (
            <div>
              <p className="font-medium text-paper">Explore</p>
              <ul className="mt-3 space-y-2 text-paper/65">
                {categories.slice(0, 5).map((category) => (
                  <li key={category.id}>
                    <Link
                      to={`/courses?category=${category.id}`}
                      className="hover:text-accent"
                    >
                      {category.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col items-center gap-2 border-t border-paper/10 py-4 text-center text-xs text-paper/50 sm:flex-row sm:justify-between sm:px-10">
        <span>
          © {new Date().getFullYear()} Become A Doer. Made for people who
          build.
        </span>
        <span className="flex items-center gap-3">
          <Link to="/terms" className="hover:text-accent">
            Terms
          </Link>
          <Link to="/privacy" className="hover:text-accent">
            Privacy
          </Link>
          <Link to="/contact" className="hover:text-accent">
            Contact
          </Link>
        </span>
      </div>
    </footer>
  )
}
